import type { AnnotationTarget } from "./anchor";

export const ANNOTATION_KINDS = ["highlight", "note", "bookmark"] as const;
export const ANNOTATION_COLORS = [
  "yellow",
  "green",
  "blue",
  "rose",
] as const;
export const ANNOTATION_SIDES = ["left", "right"] as const;
export const NOTE_BODY_FORMAT = "markdown+typst-v1" as const;

export type AnnotationKind = (typeof ANNOTATION_KINDS)[number];
export type AnnotationColor = (typeof ANNOTATION_COLORS)[number];
export type AnnotationPreferredSide = (typeof ANNOTATION_SIDES)[number];

export type AnnotationRecord = {
  schemaVersion: 1;
  id: string;
  documentId: string;
  pageIndex: number;

  kind: AnnotationKind;
  target: AnnotationTarget;

  body: {
    format: typeof NOTE_BODY_FORMAT;
    source: string;
  } | null;

  color: AnnotationColor | null;
  preferredSide: AnnotationPreferredSide | null;
  tags: string[];
  conflictOf: string | null;

  revision: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};
